import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import './AllAdminServices.css';
import { useParams } from 'react-router-dom';
import { adminAuth } from '../../../config';
import { BASE_URL_APISERVICES } from '../../../utils/Constants';
import { API_ENDPOINTS } from '../../../utils/apiEndpoints';

export default function AllAdminServices() {
    const { id } = useParams();
    const { username1, password1 } = adminAuth;
    const [searchTerm, setSearchTerm] = useState("");
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(10);

    const accessInfo = async () => {
        if (!id) return;
        try {
            setLoading(true);
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append(
                "Authorization",
                "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
                );
                
            const raw = JSON.stringify({
                userid: id,
                service: "",
                status: "",
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const res = await fetch(
                `https://api.bumppypay.com/api/Admin/admin/get_admin_access_info`,
                requestOptions
            );
            const result = await res.json();

            if (result.status === "0") {
                setServices(result.services || []);
            } else {
                setServices([]);
            }
        } catch (error) {
            console.error("Error fetching services:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleToggleStatus = (serviceId, currentStatus) => {
        const newStatus = currentStatus === "Y" ? "N" : "Y";
        let updatedServicesForAPI = services.map(s =>
            s.pk_menu_id === serviceId ? { ...s, status: newStatus } : s
        );
        const servicesString = updatedServicesForAPI
            .filter(e => e.status === "Y")
            .map(e => e.pk_menu_id)
            .join(",");
       
        const actionText = currentStatus === "Y" ? "Deactivate" : "Activate";

        swal({
            title: "Are you sure?",
            text: `Do you want to ${actionText} this service access?`,
            icon: "warning",
            buttons: ["Cancel", "Yes, Update it!"],
            dangerMode: currentStatus === "Y",
        })
            .then(async (willUpdate) => {
                if (willUpdate) {
                    try {

                        setServices(prev => prev.map(s =>
                            s.pk_menu_id === serviceId ? { ...s, status: newStatus } : s
                        ));

                        const myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/json");

                        const raw = JSON.stringify({
                            userid: id,
                            services: servicesString
                        });

                        const res = await fetch(`${BASE_URL_APISERVICES}${API_ENDPOINTS.update_admin_access}`, {
                            method: "POST",
                            headers: myHeaders,
                            body: raw
                        });

                        const data = await res.json();

                        if (data.status === "0") {
                            swal("Success", data.msg, "success");
                        } else {
                            throw new Error(data.msg);
                        }

                    } catch (error) {
                       
                        setServices(prev => prev.map(s =>
                            s.pk_menu_id === serviceId ? { ...s, status: currentStatus } : s
                        ));
                        swal("Error", "Could not update status. Please try again.", "error");
                    }
                }
            });
    };

    useEffect(() => {
        accessInfo();
    }, [id]);

    const filteredServices = services?.filter((service) =>
        service.menu_title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredServices?.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredServices.length / recordsPerPage);
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);
    return (
        <div className="bp-svc-container">
            <div className="bp-svc-card">
             
                <div className="bp-svc-header">
                    <h2 className="bp-svc-title">Admin Services</h2>
                    <input
                        type="text"
                        placeholder="Search services..."
                        className="bp-svc-input"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

             
                <div style={{ overflowX: 'auto' }}>
                    <div className="bp-svc-table-div">
                        <div className="bp-svc-thead">
                            <div className="bp-svc-th">SR.</div>
                            <div className="bp-svc-th">Service Name</div>
                            <div className="bp-svc-th bp-svc-center">Action</div>
                        </div>

                        <div className="bp-svc-tbody">
                            {loading ? (
                                <div style={{ padding: '2rem', textAlign: 'center', color: '#6b7280' }}>
                                    Loading services...
                                </div>
                            ) : (
                                currentRecords.map((service, index) => (
                                    <div className="bp-svc-tr" key={service.pk_menu_id}>
                                        <div className="bp-svc-td" style={{ color: '#9ca3af' }}>
                                            {indexOfFirstRecord + index + 1}
                                        </div>
                                        <div className="bp-svc-td" style={{ fontWeight: '600', color: '#1f2937', textTransform: 'uppercase' }}>
                                            {service.menu_title}
                                        </div>
                                        <div className="bp-svc-td bp-svc-center">
                                            <label className="bp-svc-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={service.status === "Y"}
                                                    onChange={() => handleToggleStatus(service.pk_menu_id, service.status)}
                                                />
                                                <div className="bp-svc-slider"></div>
                                            </label>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>

               
                {/* <div className="bp-svc-footer">
                    <div className="bp-svc-info-text">
                        Showing <b>{indexOfFirstRecord + 1}</b> to <b>{Math.min(indexOfLastRecord, filteredServices.length)}</b> of <b>{filteredServices.length}</b>
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <button
                            className="bp-svc-page-btn"
                            onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                            disabled={currentPage === 1}
                        >
                            Previous
                        </button>
                        <div style={{ display: 'flex', gap: '4px' }}>
                            {[...Array(totalPages)].map((_, i) => (
                                <button
                                    key={i}
                                    className={`bp-svc-num-btn ${currentPage === i + 1 ? 'active' : ''}`}
                                    onClick={() => setCurrentPage(i + 1)}
                                >
                                    {i + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            className="bp-svc-page-btn"
                            onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
                            disabled={currentPage === totalPages || totalPages === 0}
                        >
                            Next
                        </button>
                    </div>
                </div> */}
            </div>
        </div>
    )
}

